import React from 'react';
import CheckIcon from '$assets/svgs/white-check.svg?react';
import './styles.scss';

export interface TimelineEvent {
  id: string;
  title: string;
  timestamp: string;
}

interface TimelineItemProps {
  event: TimelineEvent;
}

export const TimelineItem: React.FC<TimelineItemProps> = ({event}) => {
  return (
    <div className="timeline-item">
      <div className="timeline-item-icon">
        <CheckIcon className="check-icon" />
      </div>
      <div className="timeline-item-content">
        <h3 className="timeline-item-title">{event.title}</h3>
        <p className="timeline-item-timestamp">{event.timestamp}</p>
      </div>
    </div>
  );
};
